var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutomotiveDealership = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Navigation-Monitor--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Navigation Monitor Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0h-21A1.5 1.5 0 0 0 0 1.5v16A1.5 1.5 0 0 0 1.5 19h21a1.5 1.5 0 0 0 1.5 -1.5v-16A1.5 1.5 0 0 0 22.5 0Zm-1 14.5a0.5 0.5 0 0 1 -0.5 0.5H3a0.5 0.5 0 0 1 -0.5 -0.5v-12A0.5 0.5 0 0 1 3 2h18a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.35 20.68a0.53 0.53 0 0 0 -0.35 -0.18h-4a0.53 0.53 0 0 0 -0.38 0.18l-2.1 2.53a0.49 0.49 0 0 0 0 0.52A0.48 0.48 0 0 0 8 24h8a0.51 0.51 0 0 0 0.41 -0.79Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.48 8.27a0.28 0.28 0 0 1 -0.12 -0.16l-0.69 -2.78A1.75 1.75 0 0 0 14 4h-4a1.75 1.75 0 0 0 -1.7 1.33l-0.66 2.78a0.28 0.28 0 0 1 -0.12 0.16 2 2 0 0 0 -0.13 3.38 0.26 0.26 0 0 1 0.11 0.21v0.89a0.75 0.75 0 0 0 1.5 0v-0.5a0.25 0.25 0 0 1 0.25 -0.25h5.5a0.25 0.25 0 0 1 0.25 0.25v0.5a0.75 0.75 0 0 0 1.5 0v-0.89a0.26 0.26 0 0 1 0.11 -0.21 2 2 0 0 0 -0.13 -3.38Zm-1.81 -0.37a0.26 0.26 0 0 1 -0.2 0.1H9.53a0.25 0.25 0 0 1 -0.24 -0.31l0.5 -2A0.26 0.26 0 0 1 10 5.5h4a0.26 0.26 0 0 1 0.24 0.19l0.5 2a0.26 0.26 0 0 1 -0.07 0.21Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutomotiveDealership);
export default ForwardRef;